/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { NodeDependencies } from './dependenciesNode.generated';
import { createOperatorNode } from '../../factoriesAny.js';
export var OperatorNodeDependencies = {
  NodeDependencies: NodeDependencies,
  createOperatorNode: createOperatorNode
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesOperatorNode.generated.js
// module id = 181
// module chunks = 0